import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { registerSW } from 'virtual:pwa-register';
import { queryClient } from './api.ts';
import { App } from './App.tsx';
import { newVersion, reloadsAtPageChange } from './update.ts';
import './styles.css';

// A new release never reloads the page under someone's work (P-37): it is loaded at the next page change (update.ts).
registerSW({ immediate: true, onNeedReload: newVersion });

// A data router, so leaving a page with changes not saved can be held and asked first (react-router's `useBlocker`,
// P-29); the app's own <Routes> stay as they were, every address under the one route.
const router = createBrowserRouter([{ path: '*', element: <App /> }]);
let at = router.state.location.key;
router.subscribe((state) => {
  if (state.location.key === at) return;
  at = state.location.key;
  if (reloadsAtPageChange()) window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
